export default __webpack_public_path__ + "static/media/verification2.971a188f.png";